import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useSelector } from "react-redux";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { centralizedClipAssetIdSelector } from "~/store/centralizedClip/selectors";
import { canChangeAssetCustomFields } from "~/utils/permissions/assetPermissions";
import { PublicAssetCustomFieldPlainText } from "./PublicAssetCustomFieldPlainText";
import { PublicAssetPanelCustomFieldContainer } from "./PublicAssetPanelCustomFieldContainer";
export const PublicAssetPanelCustomFieldPlainText = /*#__PURE__*/ memo((param)=>{
    let { field } = param;
    const assetId = useSelector(centralizedClipAssetIdSelector);
    const { permissions } = usePublicPermissions();
    const canEditCustomFields = canChangeAssetCustomFields(permissions);
    return /*#__PURE__*/ _jsx(PublicAssetPanelCustomFieldContainer, {
        field: field,
        children: /*#__PURE__*/ _jsx(PublicAssetCustomFieldPlainText, {
            field: field,
            trackingLocation: "asset-details",
            assetId: assetId,
            canEditCustomFields: canEditCustomFields
        })
    });
});
PublicAssetPanelCustomFieldPlainText.displayName = "PublicAssetPanelCustomFieldPlainText";
